// The bell's view of the socket's private_chat push: one entry per sender with
// a new unread message. The push is keyed by the other player's id; the
// receiver's copy has unread: true, the sender's own copy unread: false.
// Typing indicators and deleted messages carry no text and are skipped.
import { plainRoomLinkText } from 'functions/roomLinks';

const EXCERPT_LENGTH = 140;

// Plain text cut like services\notifications\NotificationFeed::excerpt.
function excerpt(text) {
	// DOMParser builds an inert document: nothing in the message loads or runs.
	const parsed = new DOMParser().parseFromString(text, 'text/html');
	const plain = (parsed.body.textContent || '').replace(/\s+/g, ' ').trim();
	if(plain.length <= EXCERPT_LENGTH) {
		return plain;
	}
	return `${plain.slice(0, EXCERPT_LENGTH - 1).trimEnd()}…`;
}

function newestMessage(chatMessages) {
	return Object.values(chatMessages || {})
		.filter((message) => message && !message.deleted && !message.state_message && typeof message.message === 'string' && message.message !== '')
		.sort((first, second) => Number(second.id) - Number(first.id))[0] || null;
}

export default function directMessagePushes(privateChat) {
	return Object.entries(privateChat || {}).reduce((pushes, [otherPlayerId, chat]) => {
		if(!chat || chat.unread !== true) {
			return pushes;
		}
		const message = newestMessage(chat.chat_messages);
		if(!message) {
			return pushes;
		}
		const sender = message.player && message.player.id
			? { id: Number(message.player.id), username: message.player.username }
			: { id: Number(chat.id || otherPlayerId), username: chat.username };
		pushes.push({ sender, preview: excerpt(plainRoomLinkText(message.message, message.linked_rooms)), sentAt: message.time || null });
		return pushes;
	}, []);
}
